import { useQuery } from "@tanstack/react-query";
import { getTournaments } from "@/lib/api";
import { useScopedKey } from "@/lib/queryClient";
export function useTournaments(
  teamId: string | null,
  seasonId: string | undefined,
) {
  const key = useScopedKey("tournaments", { teamId, seasonId });
  return useQuery({
    queryKey: key,
    queryFn: () => getTournaments(teamId!, seasonId!),
    enabled: !!teamId && !!seasonId,
  });
}
